<img src="assets/img/qr-code.svg" alt="qr code" class="separate-link-image" loading="lazy">